module.exports = __webpack_public_path__ + "static/img/youhuiquan_blank.c48700e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgage/youhuiquan_blank.png
// module id = hFqa
// module chunks = 1